import {
  ButtonGroup,
  Checkbox,
  Chip,
  ClickAwayListener,
  FormControlLabel,
  Grid,
  InputAdornment,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import { Slider as MuiSlider } from '@material-ui/core';
import {
  Theme,
  createStyles,
  lighten,
  makeStyles,
  useTheme,
  withStyles,
} from '@material-ui/core/styles';
import {
  CheckBox,
  CheckBoxOutlineBlank,
  Delete,
  Info,
  Edit,
  ReportProblem,
} from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { EditText } from 'react-edit-text';

import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { Paper } from '@material-ui/core';
import {
  BROKER_POINTS_OPTIONS,
  LoanSubType,
  MULTIFAMILY_5_PLUS,
  PPP_0_NO_PREPAY,
  PURCHASE,
  Roles,
  debounce,
  insertIf,
  isNil,
  isNotBlank,
  loanTermRateTermMapping,
  prePaymentPenaltyOptionsSingleProperty,
} from '@roc/feature-utils';
import {
  RadioField,
  SelectField,
  Slider,
  IconButton,
  Tooltip,
  NumberFormat,
  TextField,
  CurrencyField,
  PercentageField,
  ConfirmDialog,
  Button,
} from '@roc/ui';
import { formatCurrency, formatPercentage } from '@roc/ui/utils';
import { observer } from 'mobx-react';

import { Alert, AlertTitle } from '@material-ui/lab';
import { useBaseStore, useHeaderHeight, useUserStore } from '@roc/feature-app-core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import clsx from 'clsx';
import { boxShadow } from 'html2canvas/dist/types/css/property-descriptors/box-shadow';

import { CustomQuote, RateScenario } from '@roc/feature-types';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useLoanSummaryStore } from '@roc/feature-loan-summary';
import {
  amortizationOptions,
  amortizationTypeTooltip,
} from '@roc/feature-loans';
import { ClosingFeesTable } from './pricerSummaryClosingFeesTable';
import {
  DSCR_EXPANDED,
  rateTypeToLoanTerm,
} from 'libs/feature-loans/src/loanSubmission/stores/common/pricerSummaryHelper';
import {
  AnimatedTypography,
  PercentagePicker,
  PricerRateSlider,
} from './pricerRateSlider';
import {
  RateRangeSlider,
  AmortizationTypeField,
  RateTypeField,
  PrePaymentPenaltyField,
  LoanToValueField,
  BrokerPointsField,
  HudPaymentField,
  TargetRateInputField,
  Accordion,
  AccordionSummary,
  AccordionActions,
  AccordionDetails,
  CustomSlider,
  RateScenarioCard,
  ErrorMessageCard,
  PercentageWithInputPicker,
} from './pricerSummaryTermV2Components';
import { PricerSummaryV2Quote } from './pricerSummaryTermV2Quote';
import { PointsFeesAllocationTable } from './pricerSummaryPointFeesAllocation';
import { DownloadableQuotesDialog } from './downloadableQuoteDialog';
import { SinglePropertyRentalQuoteStore } from '../../stores/singlePropertyRentalQuoteStore';
import { QuoteTypeStore } from '../../stores/quoteTypeStore';
import { QuoteStep } from '../../utils/constants';
import { useOneToolStore } from '../../hooks/useOneToolStore';

interface PricerSummaryTermProps {
  store: QuoteTypeStore;
  onNext?: () => void;
}

const useStyles = makeStyles(theme => ({
  slider: {
    marginTop: '2.5em',
    marginLeft: '16px',
    width: '90%',
  },
  errorContainer: {
    color: theme.palette.error.main,
  },
  selectedRate: {
    color: theme.palette.primary.dark,
  },
  targetRateField: {
    '& input': {
      fontSize: 24,
      fontWeight: 'bold',
      color: theme.palette.primary.dark,
    },
    '& .MuiInputAdornment-root p': {
      fontSize: 24,
      fontWeight: 'bold',
      color: theme.palette.primary.dark,
    },
    '& .MuiInputBase-root': {
      maxHeight: '52px',
    },
  },
  noteText: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(4),
  },
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  details: {
    alignItems: 'center',
  },
  column: {
    flexBasis: '33.33%',
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  chooseScenario: {
    '& .MuiFormControlLabel-root': {
      paddingRight: '8px',
      marginLeft: 0,
      marginTop: 8,
      '&:hover': {
        background: '#e4f3f7',
      },
      '&.isSelected': {
        background: '#bae2ef',
        '&:hover': {
          background: '#bae2ef',
        },
      },
    },
  },
  selectField: {
    '& .MuiSelect-root': {
      padding: '8px 32px 8px 8px',
    },
  },
  percentField: {
    '& .MuiInputBase-input': {
      padding: '8px 32px 8px 8px',
    },
  },
  editTextContainer: {
    '&>div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& input': {
      textAlign: 'center',
    },
  },
  removeQuoteButton: {
    color: '#00BCD4',
    marginTop: 4,
    textTransform: 'unset',
    '& .MuiButton-startIcon': {
      marginRight: 4,
    },
  },
  youMakeContainer: {
    position: 'absolute',
    right: -1,
    top: -50,
    zIndex: 1,
  },
  youMakeContainerBorder: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: -1,
    height: 51,
    border: '1px solid #e0e0e0',
    borderBottomWidth: 0,
    width: '100%',
    background: '#fff',
    '&.expanded': {
      boxShadow: '0px 0px 16px 0px #757373',
    },
  },
  youMakeContent: {
    padding: '8px 16px',
    margin: 1,
    background: '#d1f9d1',
  },
  validationError: {
    border: '1px solid',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
}));

export const PricerSummaryTermV2 = observer(
  ({ store, onNext }: PricerSummaryTermProps) => {
    const classes = useStyles();

    const { pricerSummaryStore, pricerStore } = store;
    const {
      overRideRate,
      currentMinLtv,
      currentMaxLtv,
      showRateNotFoundErrorMsg,
      loanStandardRatesRows,
    } = pricerSummaryStore;
    const { maxYsp } = pricerSummaryStore.pricerLoanTerms;
    const { targetLTV } = pricerStore.form.fields;
    const [showLoanRatesDialog, setShowLoanRatesDialog] = useState(false);
    const { loanToValue } = pricerSummaryStore.form.fields;

    async function fetchDSCRRates() {
      await pricerSummaryStore.fetchDSCRRates();
    }

    useEffect(() => {
      fetchDSCRRates();
    }, [pricerSummaryStore.rateForDSCR]);

    useEffect(() => {
      if (!loanToValue.value) {
        pricerSummaryStore.setLoanToValue(targetLTV.value);
      }
      pricerSummaryStore.fetchRatesAndLoanTermsV2();
      pricerSummaryStore.fetchRatesForCustomQuotes();
    }, []);

    const buildBuydownOptions = () => {
      let buydownList = [];
      const maxValue =
        pricerSummaryStore.maxAllowedBuydown > 0
          ? pricerSummaryStore.maxAllowedBuydown * 100
          : pricerSummaryStore.maxAllowedBuydownStandard * 100;
      const maxValueRatio = pricerSummaryStore.buydownRatio
        ? pricerSummaryStore.buydownRatio
        : pricerSummaryStore.buydownRatioStandard;
      for (let buydown = 0; buydown <= maxValue; buydown++) {
        let buydownPoints = (buydown / maxValueRatio / 100).toFixed(3);
        let buydownDecimal = buydown / 100;
        buydownList.push({
          value: buydownDecimal,
          label: `${buydownDecimal}% (${buydownPoints} pts)`,
        });
      }
      return buydownList;
    };

    const showRatesTable =
      (!showRateNotFoundErrorMsg && !overRideRate) || loanStandardRatesRows;

    return (
      <Grid
        container
        style={{
          maxWidth: 1200,
          margin: 'auto',
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            marginBottom: 32,
          }}
        >
          <Typography
            variant="h4"
            style={{ fontWeight: 'bold', marginBottom: 8 }}
          >
            Loan Pricer Summary
          </Typography>
          <Typography variant="body1" style={{ color: '#666' }}>
            Compare and save your best loan rate options
          </Typography>
        </Grid>
        <Grid item xs={12} style={{}}>
          <DetailedAccordion
            store={store}
            setShowLoanRatesDialog={setShowLoanRatesDialog}
            onNext={onNext}
          />
        </Grid>
        <DownloadableQuotesDialog
          store={store}
          open={showLoanRatesDialog}
          rateBuydownOptions={buildBuydownOptions()}
          onClose={() => setShowLoanRatesDialog(false)}
        />
      </Grid>
    );
  }
);

const pointFormatOptions = [
  { label: 'Percentage', value: 'percentage' },
  { label: 'Amount', value: 'amount' },
];

interface DetailedAccordionProps {
  store: SinglePropertyRentalQuoteStore;
  setShowLoanRatesDialog: (value: boolean) => void;
  onNext?: () => void;
  onSubmit?: (customQuote?: CustomQuote) => Promise<void>;
  isPricingTab?: boolean;
  hasPreloadedQuote?: boolean;
  loanDetails?: any;
}

export const DetailedAccordion = observer(
  ({
    store,
    setShowLoanRatesDialog,
    onNext = () => { },
    onSubmit,
    isPricingTab = false,
    hasPreloadedQuote = false,
    loanDetails,
  }: DetailedAccordionProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const [expanded, setExpanded] = React.useState<string | false>(
      isPricingTab && hasPreloadedQuote ? 'panel0' : false
    );
    const {
      pricerSummaryStore,
      pricerStore,
      userStore,
      propertiesStore,
    } = store;
    const { isBroker } = pricerSummaryStore;
    const { oneToolStore } = useOneToolStore();
    const { rentalPortfolioQuoteStore } = oneToolStore;
    const { portfolioInformationFormStore } = rentalPortfolioQuoteStore;
    const rentalValues = portfolioInformationFormStore.getFormValues();
    const propertyType =
      pricerStore.isSingleProperty &&
        propertiesStore.propertyFormStores?.length > 0
        ? propertiesStore.propertyFormStores[0]?.form.fields.propertyType.value
        : null;
    const loanPurpose =
      pricerStore.isSingleProperty &&
        propertiesStore.propertyFormStores?.length > 0
        ? propertiesStore.propertyFormStores[0]?.form.fields.loanPurpose.value
        : rentalValues.loanPurpose;
    const purchasePrice =
      pricerStore.isSingleProperty &&
        propertiesStore.propertyFormStores?.length > 0
        ? propertiesStore.propertyFormStores[0]?.form.fields.purchasePrice.value
        : rentalValues.acquisitionPrice;
    const isBackOfficeProcessor = userStore.userInformation?.roles?.includes(
      Roles.BACK_OFFICE_PROCESSOR
    );
    const propertyValueBasedOnLoanType =
      pricerStore.isSingleProperty &&
        propertiesStore.propertyFormStores?.length > 0
        ? propertiesStore.propertyFormStores[0]?.form.fields.currentMarketValue
          .value
        : portfolioInformationFormStore.totalEstimatedAsIsValue;
    const asIsValue =
      loanPurpose == PURCHASE
        ? Math.min(propertyValueBasedOnLoanType, purchasePrice)
        : propertyValueBasedOnLoanType;
    const allowLoanPricing = userStore.allowLoanPricing;

    const [editRateMode, setEditRateMode] = React.useState(false);
    const [editFeesMode, setEditFeesMode] = React.useState(false);
    const [isConfirmSubmitOpen, setIsConfirmSubmitOpen] = React.useState(false);
    const [validationErrorOpen, setValidationErrorOpen] = React.useState([]);
    const {
      brokersStore,
      loanStore,
      termStore,
      fixFlipStore,
      stabilizedBridgeStore,
      globalStore,
    } = useStore();
    const showBrokerPaymentQuestion = globalStore.lenderInfo?.isInternal === true;
    const { loanSummaryStore } = useLoanSummaryStore();
    const [editLoanJson, setEditLoanJson] = useState(null);
    const [
      quoteIndexDuringConfirm,
      setQuoteIndexDuringConfirm,
    ] = React.useState(0);

    useEffect(() => {
      if (!showBrokerPaymentQuestion) {
        brokersStore.setOnTheHud(true);
        store.brokerStore?.brokerFormStore?.onFieldChange('brokerType', 'ON_THE_HUD');
        return;
      }
      const referralFee =
        store.loanDetailsStore?.form?.fields?.referralFee?.value;
      if (referralFee && referralFee > 0) {
        brokersStore.setOnTheHud(false);
      }
    }, []);

    const handleConfirmSubmit = () => {
      setIsConfirmSubmitOpen(false);
      handleSubmitQuote(quoteIndexDuringConfirm);
    };

    const setRateTypeOptionsBasedOnProgramType = () => {
      return pricerSummaryStore.rateTypeOptionsStandard;
    };

    const handleChange = (panel: string) => (
      event: React.ChangeEvent<{}>,
      newExpanded: boolean
    ) => {
      setExpanded(newExpanded ? panel : false);
    };

    const handleOnChangeAmortization = value => {
      pricerSummaryStore.onFieldChange('amortization', value);
      pricerSummaryStore.fetchRatesAndLoanTermsV2();
    };

    const handleChangePrePaymentPenalty = value => {
      pricerSummaryStore.onFieldChange('prePaymentPenalty', value);
      pricerSummaryStore.fetchRatesAndLoanTermsV2();
    };

    const handleChangeLoanTerm = value => {
      pricerSummaryStore.setLoanTerm(rateTypeToLoanTerm[value]);
      pricerSummaryStore.onFieldChange('rateType', value);
      pricerSummaryStore.onFieldChange(
        'prePaymentPenalty',
        pricerSummaryStore.defaultPrepay
      );
      pricerSummaryStore.fetchRatesAndLoanTermsV2();
    };

    const debouncedFetchRatesAndLoanTermsV2 = React.useMemo(
      () => debounce(() => {
        pricerSummaryStore.fetchRatesAndLoanTermsV2();
      }, 750),
      [pricerSummaryStore.fetchRatesAndLoanTermsV2]
    );

    const handleChangeYourLoanTerm = (name, value) => {
      const isDifferentValue = pricerSummaryStore.form.fields[name]?.value !== value;
      pricerSummaryStore.isManualLtvSet = true;
      pricerSummaryStore.onFieldChange(name, value);
      if (isDifferentValue) {
        debouncedFetchRatesAndLoanTermsV2();
      }
    };

    const handleChangeCommittedRateSlider = (cRate, quoteIndex, value) => {
      pricerSummaryStore.adjustRatesAndLoanTermsForCustomQuote(
        cRate,
        quoteIndex,
        value
      );
    };

    const handleEditRate = () => {
      setEditRateMode(true);
    }

    const handleSubmitQuote = async (quoteIndex: number) => {
      if (onSubmit) {
        pricerSummaryStore.selectCustomQuote(quoteIndex);
        const quote = pricerSummaryStore.customQuotes?.[quoteIndex];
        await onSubmit(quote);
      } else {
        pricerSummaryStore.selectCustomQuote(quoteIndex);
        store.goToStep(QuoteStep.SUMMARY);
      }
    };

    const handleOpenValidationError = (e, id, open) => {
      setValidationErrorOpen(validationErrorOpen => {
        const index = validationErrorOpen.findIndex(error => error.id === id);
        const newList = [...validationErrorOpen];
        if (index > -1) {
          newList.splice(index, 1);
        }
        newList.push({ id: id, open: !open, anchorEl: e.target });
        return newList;
      });
    };

    const handleCloseValidationError = value => {
      setValidationErrorOpen([]);
    };

    const resetReferralFeeAndBrokerPoints = () => {
      store.loanDetailsStore.onFieldChange('brokerPointsIn', 0);
      store.loanDetailsStore.changePointsPercentage(
        'referralFee',
        0,
        'referralFeesAmount',
        (pricerSummaryStore.form.fields.loanToValue?.value * asIsValue) / 100 ||
        0
      );
    };

    const handleHudChange = value => {
      if (value.toLowerCase() === 'true') {
        brokersStore.setOnTheHud(true);
        resetReferralFeeAndBrokerPoints();
      } else {
        brokersStore.setOnTheHud(false);
        resetReferralFeeAndBrokerPoints();
      }
    };

    const handleCompare = () => {
      setShowLoanRatesDialog(true);
    };

    const ReferralFees = observer(({ store }) => {
      const formFields = store.loanDetailsStore.form.fields;
      useEffect(() => {
        brokersStore.setIsTermLoan(true);
      }, []);

      return (
        <Grid item xs={6} style={{ alignSelf: 'flex-start' }}>
          <Box mb={2} mr={4} mt={1}>
            <RadioField
              standaloneLabel
              label="Referral Fee"
              value={formFields.referralFeesFormat.value}
              errorText={formFields.referralFeesFormat.error}
              error={isNotBlank(formFields.referralFeesFormat.error)}
              name={'referralFeesFormat'}
              options={pointFormatOptions}
              onChange={value => {
                store.loanDetailsStore.onChange('referralFeesFormat', value);
                store.loanDetailsStore.changePointsPercentage(
                  'referralFee',
                  formFields.referralFee.value,
                  'referralFeesAmount',
                  (pricerSummaryStore.form.fields.loanToValue?.value *
                    asIsValue) /
                  100 || 0
                );
              }}
              fullWidth
              row
              required
              testId="referralFeesFormat"
            />
            {formFields.referralFeesFormat.value ===
              pointFormatOptions[0].value && (
                <NumberFormat
                  testId="referralFee"
                  required
                  customInput={TextField}
                  variant="outlined"
                  value={formFields.referralFee.value}
                  onChange={e =>
                    store.loanDetailsStore.changePointsPercentage(
                      'referralFee',
                      e.target.value,
                      'referralFeesAmount',
                      (pricerSummaryStore.form.fields.loanToValue?.value *
                        asIsValue) /
                      100 || 0
                    )
                  }
                  decimalScale={2}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                  error={isNotBlank(formFields.referralFee.error)}
                  helperText={formFields.referralFee.error}
                  fullWidth
                  standaloneLabel
                />
              )}
            {formFields.referralFeesFormat.value ===
              pointFormatOptions[1].value && (
                <CurrencyField
                  variant="outlined"
                  standaloneLabel
                  value={formFields.referralFeesAmount.value}
                  errorText={formFields.referralFee.error}
                  error={isNotBlank(formFields.referralFee.error)}
                  onChange={(name, value) =>
                    store.loanDetailsStore.changePointsAmount(
                      'referralFeesAmount',
                      value,
                      'referralFee',
                      (pricerSummaryStore.form.fields.loanToValue?.value *
                        asIsValue) /
                      100 || 0
                    )
                  }
                  fullWidth
                  required
                  testId="referralFeesNumber"
                />
              )}
          </Box>
        </Grid>
      );
    });

    const ratesScenarios = pricerSummaryStore.ratesScenarios as RateScenario[];
    const customQuotes = pricerSummaryStore.customQuotes as CustomQuote[];
    const formFields = pricerSummaryStore.form.fields;

    const brokerPointsChangeHandler = value => {
      const isTerm = [
        LoanSubType.RENTAL_PORTFOLIO,
        LoanSubType.SINGLE_PROPERTY,
      ].includes(store.loanSubtype);
      if (isTerm) {
        store.brokerStore.brokerFormStore.onFieldChange('brokerPoints', value);
        store.brokerStore.brokerFormStore.onFieldChange('hasBroker', value > 0);
      }
      store.loanDetailsStore.onFieldChange('brokerPointsIn', value);
    };

    const handleAddToQuote = (scenario: RateScenario) => {
      // Only pass loanDetails when this is actually pricingTab component
      pricerSummaryStore.addCustomQuote(scenario, isPricingTab ? loanDetails : undefined);
      setExpanded(`panel${customQuotes.length}`);
      setTimeout(() => {
        (window as any).scrollTo(0, document.body.scrollHeight);
      }, 100);
    };

    const selectedQuotesCount = customQuotes.filter(q => q.compare).length;

    return (
      <div className={classes.root}>
        <Box
          width="100%"
          mb={3}
          p={3}
          style={{
            background: '#fafafa',
          }}
        >
          <Box
            mb={2}
            p={3}
            width="100%"
            style={{
              background: '#fff',
              border: '1px solid #e0e0e0',
              borderRadius: 8,
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Box mb={3}>
                  <Typography
                    variant="h5"
                    gutterBottom
                    style={{
                      fontWeight: 'bold',
                      // fontSize: 18,
                    }}
                  >
                    Rental Pricer Tool
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box mb={2}>
                  <Typography
                    gutterBottom
                    style={{
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    Loan Terms
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <AmortizationTypeField
                  value={formFields.amortization.value}
                  onChange={handleOnChangeAmortization}
                  className={classes.selectField}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <RateTypeField
                  value={formFields.rateType.value}
                  onChange={handleChangeLoanTerm}
                  options={setRateTypeOptionsBasedOnProgramType()}
                  className={classes.selectField}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <PrePaymentPenaltyField
                  value={formFields.prePaymentPenalty.value}
                  onChange={handleChangePrePaymentPenalty}
                  options={
                    pricerSummaryStore.prepaymentPenaltyOptions ??
                    prePaymentPenaltyOptionsSingleProperty
                  }
                  className={classes.selectField}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <PercentageWithInputPicker
                  label="Loan To Value"
                  value={formFields.loanToValue.value}
                  onChange={(value) =>
                    handleChangeYourLoanTerm('loanToValue', value)
                  }
                />
              </Grid>
              {!isPricingTab && (
                <Grid container spacing={4} alignItems="flex-start">
                  {!brokersStore.onTheHud && showBrokerPaymentQuestion ? (
                    <ReferralFees store={store} />
                  ) : (
                    <BrokerPointsField
                      value={
                        store.brokerStore.brokerFormStore.form.fields
                          .brokerPoints.value
                      }
                      onChange={brokerPointsChangeHandler}
                      className={classes.selectField}
                    />
                  )}
                  {showBrokerPaymentQuestion && (
                    <HudPaymentField
                      value={brokersStore.onTheHud}
                      onChange={value => handleHudChange(value)}
                      noteText="Note: Brokers paid on the HUD will have a separate broker line item and brokers paid off the HUD will have their fee rolled into origination points."
                      noteClassName={classes.noteText}
                    />
                  )}
                </Grid>
              )}
              <Grid item xs={12}>
                {store.isEditingLoan && (
                  <Box my={2} pl={3}>
                    <Alert severity="warning" style={{ marginBottom: '8px' }}>
                      Please note all points, fees, and YSP have been reset.
                      Please add back your required points, fees, and YSP before
                      resubmitting.
                    </Alert>
                  </Box>
                )}
                <Box my={2} pl={3}>
                  <Typography
                    display="inline"
                    gutterBottom
                    style={{
                      fontWeight: 'bold',
                      fontSize: 20,
                    }}
                  >
                    Loan Amount:{' '}
                  </Typography>
                  <Typography
                    display="inline"
                    style={{
                      padding: '8',
                      fontSize: 20,
                      fontWeight: 'bold',
                      color: theme.palette.primary.dark,
                    }}
                  >
                    {formatCurrency(
                      (pricerSummaryStore.form.fields.loanToValue?.value *
                        asIsValue) /
                      100 || 0
                    )}
                  </Typography>
                </Box>
                <ResultsSection
                  ratesScenarios={ratesScenarios}
                  pricerSummaryStore={pricerSummaryStore}
                  onAddToQuote={handleAddToQuote}
                  setEditRateMode={setEditRateMode}
                  handleEditRate={handleEditRate}
                  isEditRateMode={editRateMode}
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            mb={2}
            p={3}
            width="100%"
            style={{
              background: '#fff',
              border: '1px solid #e0e0e0',
              borderRadius: 8,
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}
          >
            <Box
              mb={2}
              display={'flex'}
              alignItems={'center'}
              style={{ gap: 8 }}
            >
              <Typography
                variant="h5"
                gutterBottom
                style={{
                  fontWeight: 'bold',
                  // fontSize: 18,
                  flex: 1,
                }}
              >
                Quotes
              </Typography>
              <Typography
                variant="body2"
                style={{ color: '#666', fontSize: 14 }}
              >
                {selectedQuotesCount} of 3 selected
              </Typography>
              <Button
                onClick={handleCompare}
                testId="compare-quotes"
                variant="contained"
                color="primary"
                disabled={selectedQuotesCount === 0}
              >
                Compare/Download Quotes ({selectedQuotesCount})
              </Button>
            </Box>
            {customQuotes.length > 0 && (
              <>
                {customQuotes.map((cRate, quoteIndex) => {
                  const panelName = `panel${quoteIndex}`;
                  const isExpanded = expanded === panelName;
                  const rateAvailable = !isNil(cRate.rate) && cRate.rate > 0;
                  const goodToSubmitQuote =
                    rateAvailable &&
                    pricerSummaryStore.determineIfGoodToSubmitQuote(cRate);
                  const missingPointToRoc = pricerSummaryStore.determineIfPointToRocMissing(
                    cRate
                  );
                  return (
                    <React.Fragment key={panelName}>
                      {isPricingTab && quoteIndex === 0 && hasPreloadedQuote && (
                        <Box display="flex" alignItems="center" my={2}>
                          <Divider style={{ flex: 1 }} />
                          <Typography
                            variant="caption"
                            style={{
                              margin: '0 12px',
                              color: theme.palette.text.secondary,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Change Request
                          </Typography>
                          <Divider style={{ flex: 1 }} />
                        </Box>
                      )}
                      <PricerSummaryV2Quote
                        cRate={cRate}
                        quoteIndex={quoteIndex}
                        isExpanded={isExpanded}
                        handleChange={handleChange}
                        panelName={panelName}
                        isBackOfficeProcessor={isBackOfficeProcessor}
                        allowLoanPricing={allowLoanPricing}
                        classes={classes}
                        isBroker={isBroker}
                        pricerSummaryStore={pricerSummaryStore}
                        theme={theme}
                        rateAvailable={rateAvailable}
                        goodToSubmitQuote={goodToSubmitQuote}
                        setShowLoanRatesDialog={setShowLoanRatesDialog}
                        customQuotes={customQuotes}
                        setIsConfirmSubmitOpen={setIsConfirmSubmitOpen}
                        setQuoteIndexDuringConfirm={setQuoteIndexDuringConfirm}
                        handleSubmitQuote={handleSubmitQuote}
                        isConfirmSubmitOpen={isConfirmSubmitOpen}
                        propertyType={propertyType}
                        setRateTypeOptionsBasedOnProgramType={
                          setRateTypeOptionsBasedOnProgramType
                        }
                        handleChangeCommittedRateSlider={
                          handleChangeCommittedRateSlider
                        }
                        isPricingTab={isPricingTab}
                        isPreloadedQuote={isPricingTab && quoteIndex === 0 && hasPreloadedQuote}
                        handleConfirmSubmit={handleConfirmSubmit}
                      />
                      {isPricingTab && quoteIndex === 0 && hasPreloadedQuote && (
                        <Box display="flex" alignItems="center" my={2}>
                          <Divider style={{ flex: 1 }} />
                          <Typography
                            variant="caption"
                            style={{
                              margin: '0 12px',
                              color: theme.palette.text.secondary,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            New Quotes
                          </Typography>
                          <Divider style={{ flex: 1 }} />
                        </Box>
                      )}
                    </React.Fragment>
                  );
                })}
              </>
            )}
            {customQuotes.length === 0 && <Box>No quote selected</Box>}
          </Box>
        </Box>
      </div>
    );
  }
);

interface ResultsSectionProps {
  ratesScenarios: RateScenario[];
  pricerSummaryStore: any;
  onAddToQuote: (scenario: RateScenario) => void;
  handleEditRate: () => void;
  isEditRateMode?: boolean;
  setEditRateMode: (value: boolean) => void;
}

const ResultsSection = observer(
  ({
    ratesScenarios,
    pricerSummaryStore,
    onAddToQuote,
    handleEditRate,
    isEditRateMode,
    setEditRateMode
  }: ResultsSectionProps) => {
    const { isBroker, isInternalLender } = pricerSummaryStore;
    const [selectedRate, setSelectedRate] = useState<number>(0);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [customRate, setCustomRate] = useState<number>(pricerSummaryStore.targetRateScenario?.rate || 0);
    const handleChangeRate = (event: any, newValue: number | number[]) => {
      setEditRateMode(false);
      setSelectedRate(newValue as number);
    };
    const rates = ratesScenarios.map(s => s.rate).filter(r => r != null);
    const maxRate = rates.length > 0 ? Math.max(...rates) : 0;
    const selectedScenario = ratesScenarios.find(s => s.rate === selectedRate);
    const hasNAScenario = ratesScenarios.some((s) => s.rate == null);
    const { globalStore } = useBaseStore();

    useEffect(() => {
      setSelectedRate(maxRate);
    }, []);

    useEffect(() => {
      if(pricerSummaryStore.targetRateScenario) {
        pricerSummaryStore.targetRateScenario.rate = selectedRate;
        setCustomRate(selectedRate);
      }
    }, [selectedRate]);

    useEffect(() => {
      if (ratesScenarios.find(s => s.rate === selectedRate) == null) {
        setSelectedRate(maxRate);
      }
    }, [ratesScenarios, isEditRateMode, customRate]);

    let youMake = selectedScenario?.youMakeForWholesale || 0;
    let youMakePercent = selectedScenario?.youMakeForWholesalePercent || 0;
    if (isBroker) {
      youMake = selectedScenario?.youMakeForBroker || 0;
      youMakePercent = selectedScenario?.youMakeForBrokerPercent || 0;
    } else if (isInternalLender) {
      youMake = selectedScenario?.commissions?.commissionAmount || 0;
      youMakePercent = selectedScenario?.commissions?.commissionPercentage || 0;
    }

    return (
      <>
        <Box my={3} pl={3}>
          <Typography
            gutterBottom
            style={{
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            Results
          </Typography>
        </Box>
        <Box px={3} mb={3}>
          <RateRangeSlider
            value={selectedRate}
            isEditRateMode={isEditRateMode}
            enteredRate={customRate}
            onChange={handleChangeRate}
            ratesScenarios={ratesScenarios}
            setErrorMessage={setErrorMessage}
          />
        </Box>
        {!selectedScenario && errorMessage && (
          <Box px={3} mb={3}>
            <ErrorMessageCard message={errorMessage} />
          </Box>
        )}
        {!!selectedScenario && (
          <Box px={3} mb={3}>
            <RateScenarioCard
              scenario={isEditRateMode ? pricerSummaryStore.targetRateScenario : selectedScenario}
              youMake={youMake}
              hasNAScenario={hasNAScenario}
              isEditRateMode={isEditRateMode}
              store={pricerSummaryStore}
              youMakePercent={youMakePercent}
              onAddToQuote={() => onAddToQuote(isEditRateMode ? pricerSummaryStore.targetRateScenario : selectedScenario)}
              onEditRate={handleEditRate}
              isBroker={isBroker}
            />
          </Box>
        )}
      </>
    );
  }
);

export const RateProgramType = observer(({ store }) => {
  const classes = useStyles();
  const { pricerLoanTerms, form } = store.pricerSummaryStore;
  const { userStore } = useUserStore();
  const allowLoanPricing = userStore.allowLoanPricing;

  const handleChangeYourLoanTerm = (name, value) => {
    store.pricerSummaryStore.onFieldChange(name, value);
    store.pricerSummaryStore.setMinsAndMaxs();
    store.pricerSummaryStore.fetchRatesAndLoanTerms();
    store.pricerSummaryStore.setErrorMessages();
  };

  const setRateTypeOptionsBasedOnProgramType = () => {
    if (form.fields.programType.value === DSCR_EXPANDED) {
      return store.pricerSummaryStore.rateTypeOptions;
    } else {
      return store.pricerSummaryStore.rateTypeOptionsStandard;
    }
  };

  return (
    <Grid container xs={12} md={12} lg={12} direction="row">
      <Grid item xs={12} md={6} lg={6} style={{ paddingRight: '10px' }}>
        <SelectField
          disabled={false}
          standaloneLabel
          label={'Rate Type'}
          name={'rateType'}
          value={form.fields.rateType.value}
          options={setRateTypeOptionsBasedOnProgramType()}
          onChange={value => handleChangeYourLoanTerm('rateType', value)}
          variant="outlined"
          fullWidth
          testId="rateType"
        />
      </Grid>

      <Grid item xs={12} md={6} lg={6} style={{ paddingLeft: '10px' }}>
        <SelectField
          disabled={false}
          standaloneLabel
          label={'Program Type'}
          name={'programType'}
          value={form.fields.programType.value}
          options={store.pricerSummaryStore.programTypeOptions}
          onChange={value => handleChangeYourLoanTerm('programType', value)}
          variant="outlined"
          fullWidth
          testId="programType"
        />
      </Grid>

      <br />
    </Grid>
  );
});
